var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.646447 0.646447C0.841709 0.451184 1.15829 0.451184 1.35355 0.646447L4.5 3.79289L7.64645 0.646447C7.84171 0.451184 8.15829 0.451184 8.35355 0.646447C8.54882 0.841709 8.54882 1.15829 8.35355 1.35355L5.20711 4.5L8.35355 7.64645C8.54882 7.84171 8.54882 8.15829 8.35355 8.35355C8.15829 8.54882 7.84171 8.54882 7.64645 8.35355L4.5 5.20711L1.35355 8.35355C1.15829 8.54882 0.841709 8.54882 0.646447 8.35355C0.451184 8.15829 0.451184 7.84171 0.646447 7.64645L3.79289 4.5L0.646447 1.35355C0.451184 1.15829 0.451184 0.841709 0.646447 0.646447Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveTag);
export default __webpack_public_path__ + "static/media/RemoveTag.582606ef956d01d25d5acb02e03b05e5.svg";
export { ForwardRef as ReactComponent };